import {DeviceOrientation} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/DeviceOrientation';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class DesktopDevice extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, DesktopDevice.availableValues);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static DESKTOP = new AString('Desktop');
    public static DESKTOP_HD = new AString('Desktop HD');

    public static availableValues:Array<AString> = [
        DesktopDevice.DESKTOP,
        DesktopDevice.DESKTOP_HD
    ];

    public static desktop():DesktopDevice
    {
        return new DesktopDevice(DesktopDevice.DESKTOP);
    }

    public static desktopHD():DesktopDevice
    {
        return new DesktopDevice(DesktopDevice.DESKTOP_HD);
    }

    public static fromString(value:string):DesktopDevice
    {
        return new DesktopDevice(AString.fromString(value));
    }

    public static getSize(value:AString, orientation:DeviceOrientation):{width:number; height:number}
    {
        let width:number;
        let height:number;

        switch( value.toString() )
        {
            case DesktopDevice.DESKTOP.toString():
            {
                width = 1024;
                height = 1024;
                break;
            }

            case DesktopDevice.DESKTOP_HD.toString():
            {
                width = 1440;
                height = 1024;
                break;
            }
        }

        return {width, height};
    }
}
